/**
 * Field names in the official PDF, mapped by *position on the page* (verified against the printed labels;
 * four fields in the file are named for the wrong row).
 */
export const PERMISSION_FIELDS = {
  event: 'Event', dates: 'Dates of event', description: 'Event description', ward: 'Ward', stake: 'Stake',
  leader: 'Event or activity leader', leaderPhone: 'Event or activity leaders phone number', leaderEmail: 'Event or activity leaders email',
  participant: 'Participant', dob: 'Date of birth', age: 'Age', phone: 'Telephone number', address: 'Address', city: 'City', state: 'State or Province',
  emergency: 'Emergency contact parent or guardian', emergencyPrimary: 'Primary phone_1', emergencySecondary: 'Secondary phone_1',
  specialDiet: 'Special diet', dietExplanation: 'diet explanation', allergies: 'Allergies', allergyExplanation: 'Allergy explanation',
  medications: 'List of Medications', selfAdmin: 'Self Admin',
  chronicIllness: 'Surgery',                 // checkbox on the "chronic or recurring illness" row
  chronicIllnessExplanation: 'If yes please explain_2',
  surgery: 'Chronic illness',                // checkbox on the "surgery or serious illness" row
  surgeryExplanation: 'illness explanation',
  otherLimitations: 'Special needs',         // large box under "Identify any other limits, restrictions, or disabilities"
  specialNeeds: 'Other limitations',         // large box under "Other Accommodations or Special Needs"
  participantSignature: 'Participants signature', date1: 'Date',
  parentSignature: 'Parent or guardians signature if participant is a minor', date2: 'Date_2',
  reset: 'Btn.Reset',
} as const;
